enum MiniConfigurationSummaryWhatsIncludedIconEnum {
	informationCircle = 'information-circle',
	chevronDown = 'chevron-down',
	orderedList = 'ordered-list'
}

export default MiniConfigurationSummaryWhatsIncludedIconEnum;
